import { useState, useEffect } from 'react';
import { LOAD_STATUS } from '@/components/loadable';
import { message } from 'antd';
import { requestPost } from '@/common/request';
import { batchedUpdates } from '@/common/utils';

// 关联的品类数组
export interface LinkedCategoryItem {
  categoryId: string; // 品类id
  categoryName: string; // 品类名称
  categoryDesc: string; // 品类描述
  reportErp: string; //提报人
  stageList: StageItem[]; // 品类关联的场景列表
}

// 品类的场景数组
export interface StageItem {
  stageId: string; //趋势场景id
  stageName: string; //趋势场景名称
  groupId: string; //趋势主张id
  groupName: string; //趋势主张名称
}

export interface Query {
  search?: {
    stageIds?: string[]; // 场景id列表，如果只选主张，需要把主张下面的所有场景id入参
    categoryName?: string; // 品类名称
    categoryId?: string; // 品类id
    fieldId?: string; // 场域id
    needAllStages?: number; // 1-需要0-不需要 //需要场域下所有场景
  };
  bizType?: 0 | 1; // 0 已挂靠场景 1 为挂靠场景
  page?: number;
  pageSize?: number;
  extraFlag?: string; // 1 主张列表对应出参groupList 2 品类是否关联
}

type ResultData = {
  list: LinkedCategoryItem[];
  totalPage: number;
  totalNum: number;
};

// 获取全部品类
export default function queryTrendCategoryList(query: Query): Promise<RequestResult<ResultData>> {
  return requestPost('/generic/materialRpcService/queryTrendCategoryList', query);
}

export function useAPIQueryTrendCategoryList(initialQuery: Query = {}) {
  const [query, setQuery] = useState<Query>(() => Object.assign({}, { page: 1, pageSize: 10 }, initialQuery));
  const [state, setState] = useState<ResultData>({
    list: [],
    totalPage: 0,
    totalNum: 0,
  });
  const [loadStatus, setLoadStatus] = useState(LOAD_STATUS.FIRST);

  // 获取值
  useEffect(() => {
    setLoadStatus(LOAD_STATUS.ING);
    (async () => {
      try {
        const { ret, data, msg } = await queryTrendCategoryList(query);

        if (ret !== '0' || !data) {
          setLoadStatus(LOAD_STATUS.FAILED);
          return message.error(msg);
        }

        batchedUpdates(() => {
          setState((oldState) => ({ ...oldState, ...data, loading: false }));
          setLoadStatus(LOAD_STATUS.SUCCESS);
        });
      } catch (ex) {
        console.error(ex);
        setLoadStatus(LOAD_STATUS.FAILED);
        message.error('服务端异常请稍后重试');
      }
    })();
  }, [query]);

  function refresh() {
    setQuery((oldQuery) => ({ ...oldQuery }));
  }

  return [
    { query, loadStatus, loading: loadStatus === LOAD_STATUS.ING, state },
    { setQuery, refresh },
  ] as const;
}
